import WComponent from "../../common/WComponent";
import TextFieldInput from "../../common/text_field_input/TextFieldInput";
import BudgetInput from "../../common/budget_input/BudgetInput";
import RequiredLabel from "../../common/required_label";

class EngagementBudgetSettings extends WComponent {
	constructor(props) {
		super(props);

		this.state = {
			resource: "",
			budget: "",
		};
	}

	onChange = (e) => {
		const { name, value } = e.target;
		this.update({ [name]: value });

		if (this.props.onChange) {
			this.props.onChange({ [name]: value });
		}
	};

	render() {
		const { resource, budget } = this.state;

		return (
			<div className="modal-content">
				<TextFieldInput
					title={<RequiredLabel text="Resource" />}
					placeholder="e.g., Bookkeeping"
					name="resource"
					onChange={this.onChange}
					value={resource}
					autoComplete="off"
					className="ft-budget-resource-input"
				/>

				<BudgetInput name="budget" value={budget} onChange={this.onChange} />
			</div>
		);
	}
}

export default EngagementBudgetSettings;
